import { render, staticRenderFns } from "./HelpdeskTicketForm.vue?vue&type=template&id=0d2c0112&scoped=true"
import script from "./HelpdeskTicketForm.vue?vue&type=script&lang=js"
export * from "./HelpdeskTicketForm.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskTicketForm.vue?vue&type=style&index=0&id=0d2c0112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c0112",
  null
  
)

export default component.exports